import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Card } from 'shared/mui/Card';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { TooltipWithInfoIcon } from 'shared/mui/Tooltip';
import { Datagrid } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils/getColumnStyle';

export const CardStyled = styled(Card)({ background: 'transparent' });

export const CardHeaderStyled = styled(CardHeader)({ padding: '0 0 16px 0' });

export const BoxStyled = styled(Box)({
  display: 'flex',
  gap: '16px',
});

export const DatagridStyled = styled(Datagrid)({
  '& .MuiTableCell-root': {
    padding: '16px',
  },
  '& .column-originId': getColumnStyle(112),
  '& .column-delivered': getColumnStyle(112),
  '& .column-attempts': getColumnStyle(112),
  '& .column-nextAttempt': getColumnStyle(112),
});

export const TooltipWithInfoIconStyled = styled(TooltipWithInfoIcon)({
  padding: '4px',
  marginTop: '-2px',
});
